import type { PaymentsActivityTranslations } from "../interfaces/paymentsActivity";

export const paymentsActivityTranslations: PaymentsActivityTranslations = {
  // Page
  page_title: "Atividade de pagamentos",
  page_subtitle: "Entradas e envios processados em tempo real",
  page_eyebrow: "Monitor ao vivo",
  live_updated_at: "Atualizado {{time}}",
  live_refresh_aria: "Atualizar a lista",

  stats_total: "Total",
  stats_processing: "Em processo",
  stats_settled: "Liquidadas",
  stats_failed: "Falhadas",
  stats_page_scope: "Nesta página",

  // Direction tabs
  tab_payins: "Entradas",
  tab_payouts: "Envios",

  // Filters
  filter_status_label: "Status",
  filter_all_statuses: "Todos os status",
  filter_corridor_label: "Corredor",
  filter_all_corridors: "Todos os corredores",
  filter_date_label: "Período",
  filter_all_dates: "Todo o histórico",
  filter_last_days: "Últimos {{days}} dias",
  filter_clear: "Limpar filtros",

  // Status labels — one per raw backend status value (see STATUS_LABEL_KEYS); shared by pill + filter.
  status_value_created: "Pendente",
  status_value_pending: "Em processamento",
  status_value_confirmed: "Creditado",
  status_value_rejected: "Rejeitado",
  status_value_failed: "Falhou",
  status_value_reversed: "Revertido",
  status_value_processing: "Em processamento",
  status_value_paid: "Pago",
  status_value_cancelled: "Cancelado",

  // Table
  table_th_status: "Status",
  table_th_corridor: "Corredor",
  table_th_amount: "Valor (líquido)",
  table_th_reference: "Referência",
  table_th_date: "Data",
  list_group_today: "Hoje",
  list_group_yesterday: "Ontem",
  pagination_summary: "Mostrando {{from}}–{{to}} de {{total}}",
  copy_reference_aria: "Copiar",
  copy_success: "Copiado para a área de transferência",

  // Empty / error
  empty_title: "Ainda não há movimentações",
  empty_description: "Quando você processar uma entrada ou um envio, ele aparecerá aqui com status ao vivo.",
  empty_filtered_description: "Nenhuma movimentação corresponde aos filtros selecionados.",
  error_load: "Não foi possível carregar a atividade.",
  error_retry: "Tentar novamente",

  // Drawer
  drawer_title_payin: "Detalhe da entrada",
  drawer_title_payout: "Detalhe do envio",
  drawer_failure_reason: "Motivo",
  drawer_section_qr: "Cobrar",
  drawer_section_amounts: "Valores",
  drawer_amount_gross: "Valor bruto",
  drawer_amount_fees: "Taxas",
  drawer_amount_net: "Valor líquido",
  drawer_section_timeline: "Histórico de status",
  drawer_view_ledger: "Ver lançamentos contábeis",
  deeplink_not_found:
    "Não foi possível abrir a operação vinculada: ela pode não existir mais, pertencer a outra organização ou o link apontar para o tipo errado.",
  deeplink_dismiss: "Entendi",
  drawer_section_details: "Detalhes",
  drawer_meta_id: "ID",
  drawer_meta_reference: "Referência",
  drawer_meta_concept: "Conceito",
  drawer_meta_beneficiary: "Destinatário",
  drawer_meta_breb_key: "Chave Bre-B",
  drawer_meta_breb_network_reference: "ID da transação Bre-B",
  drawer_meta_created: "Criado",
  drawer_meta_expires: "Expira",
  drawer_meta_updated: "Atualizado",
  drawer_meta_evidence: "Comprovante",
  drawer_meta_evidence_open: "Abrir",

  // Timeline
  timeline_step_created: "Criado",
  timeline_step_processing: "Em processamento",
  timeline_step_credited: "Creditado",
  timeline_step_paid: "Pago",
  timeline_step_failed: "Falhou",
  timeline_step_cancelled: "Cancelado",
  timeline_source_staff: "Equipe Coloca",
  timeline_source_network: "Rede de pagamentos",
  timeline_source_system: "Sistema",
  scope_title: "Filtrado a partir das Métricas",
  scope_all_organizations: "Todas as organizações",
  scope_window_completed: "Confirmadas ou pagas de {{from}} a {{to}}",
  scope_window_created: "Criadas de {{from}} a {{to}}",
  scope_clear: "Remover este filtro",
};
